// 端末に残す「ずっと続く記録」(DOPA・格納庫の強化・記録・目標の達成)。
// localStorage が使えない時(プライベートブラウズなど)は、その回だけの記録として動く。

import { isTestMode, TEST_DOPA } from "./test-mode.js";

const KEY = "senseofdopa.save";
// 全解放モード(src/meta/test-mode.js)の記録は別の置き場所に書く(本番の記録を変えないため)
const TEST_KEY = "senseofdopa.save.test";
function keyFor(test) {
  return test ? TEST_KEY : KEY;
}

export function emptySave() {
  return {
    v: 1,
    dopa: 0, // 格納庫で使う通貨
    totalDopa: 0, // これまでに稼いだ合計
    upgrades: {}, // 格納庫の強化 { id: レベル }
    startWeapon: null, // 最初から持って出る武器(解放済みのもの)
    goals: {}, // 達成した目標 { id: true }
    cleared: {}, // クリアした面 { 面の番号: クリアした回数 }(クリアすると次の面のカードが増える)
    stageGoals: {}, // 面ごとの目標の達成 { 面の番号: { id: true } }(src/meta/goals.js の STAGE_GOALS)
    records: { runs: 0, clears: 0, bestProgress: 0, bestScore: 0, bestKills: 0, bestCombo: 0, bestLevel: 0, totalKills: 0 },
  };
}

// 足りない項目は空の値で埋める(古い形の記録を読んでも壊れないように)
export function normalize(data) {
  const base = emptySave();
  if (!data || typeof data !== "object") return base;
  return { ...base, ...data, upgrades: { ...data.upgrades }, goals: { ...data.goals }, cleared: { ...data.cleared }, stageGoals: Object.fromEntries(Object.entries(data.stageGoals || {}).map(([n, v]) => [n, { ...v }])), records: { ...base.records, ...data.records } };
}

export function loadSave(storage = globalThis.localStorage, test = isTestMode()) {
  let save;
  try {
    save = normalize(JSON.parse(storage.getItem(keyFor(test))));
  } catch {
    save = emptySave();
  }
  // 全解放モードは DOPA をいつも満タンにしておく(格納庫で何でも買える)
  if (test) save.dopa = Math.max(save.dopa, TEST_DOPA);
  return save;
}

export function writeSave(save, storage = globalThis.localStorage, test = isTestMode()) {
  try {
    storage.setItem(keyFor(test), JSON.stringify(save));
  } catch {}
}

// 選べる面の数(1面から、クリアした面の次まで。全解放モードは全部)
export function unlockedMissions(save, count, test = isTestMode()) {
  if (test) return count;
  let n = 1;
  while (n < count && save.cleared[n]) n++;
  return n;
}
